import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import ErrorBoundary from "@/components/ErrorBoundary";

// Lazy load route components for better performance
const Index = lazy(() => import("./pages/Index"));
const NotFound = lazy(() => import("./pages/NotFound"));
const ACInstallation = lazy(() => import("./pages/ACInstallation"));
const ACRepair = lazy(() => import("./pages/ACRepair"));
const AreasWeServe = lazy(() => import("./pages/AreasWeServe"));
const SuburbService = lazy(() => import("./pages/SuburbService"));
const ACMaintenance = lazy(() => import("./pages/ACMaintenance"));
const CommercialAC = lazy(() => import("./pages/CommercialAC"));
const ResidentialAC = lazy(() => import("./pages/ResidentialAC"));
const EnergyEfficient = lazy(() => import("./pages/EnergyEfficient"));
const Blog = lazy(() => import("./pages/Blog"));
const BlogPost = lazy(() => import("./pages/BlogPost"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <ErrorBoundary>
        <BrowserRouter>
          <Suspense fallback={
            <div className="flex items-center justify-center min-h-screen">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
            </div>
          }>
            <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/ac-installation" element={<ACInstallation />} />
            <Route path="/ac-repair" element={<ACRepair />} />
            <Route path="/ac-maintenance" element={<ACMaintenance />} />
            <Route path="/commercial-ac" element={<CommercialAC />} />
            <Route path="/residential-ac" element={<ResidentialAC />} />
            <Route path="/energy-efficient-ac" element={<EnergyEfficient />} />
            <Route path="/areas-we-serve" element={<AreasWeServe />} />
            <Route path="/service/:suburb" element={<SuburbService />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </ErrorBoundary>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
